import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ApexDataLabels,
  ApexLegend,
  ApexStroke,
  ApexPlotOptions,
  ApexStates,
  ApexTheme,
  ApexTitleSubtitle,
  ApexTooltip,
  ChartComponent
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  fill: any;
  stroke: ApexStroke;
  states: ApexStates;
  legend: ApexLegend;
  title: ApexTitleSubtitle;
  theme: ApexTheme;
  plotOptions: ApexPlotOptions;
  dataLabels: ApexDataLabels;
  tooltip: ApexTooltip;
  colors: any;
};

@Component({
  selector: 'app-circle-pie-chart',
  templateUrl: './circle-pie-chart.component.html',
  styleUrls: ['./circle-pie-chart.component.css']
})
export class CirclePieChartComponent implements OnInit, OnChanges {

  @Input() chartSeries: Array<any> = []
  @Input() chartSeriesLabels: Array<any> = []
  @Input() chartSeriesColors: Array<any> = []
  @Input() chartWidth: number | string = 280;
  @Input() chartHeight: number | string = 280;
  @Input() chartType: any = "donut";
  @Input() totalLabel: string = "Total";

  public chartOptions: Partial<ChartOptions>;

  constructor() {
    this.chartOptions = {
      series: [60, 40], //this.chartSeries, //[60, 40],
      colors: ['#008000', '#007bff'], //this.chartSeriesColors, // ['#008000', '#007bff'],
      chart: {
        width: this.chartWidth,
        height: this.chartHeight,
        type: this.chartType,
        dropShadow: {
          enabled: false,
          color: "#111",
          top: -1,
          left: 3,
          blur: 3,
          opacity: 0.2
        }
      },
      legend: {
        show: false
      },
      tooltip: {
        fillSeriesColor: true,
        style: {
          fontSize: '12px'
        },
      },
      stroke: {
        curve: 'smooth',
        width: 0
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                showAlways: true,
                show: true,
                label: this.totalLabel,
                fontWeight: 600
              }
            }
          }
        }
      },
      labels: this.chartSeriesLabels,
      dataLabels: {
        enabled: false,
        dropShadow: {
          blur: 3,
          opacity: 0.8
        }
      },
      fill: {
        type: "solid",
        opacity: 1,
        width: 1,
        height: 1,
        strokeWidth: 1,
        colors: ['#008000', '#007bff'], //this.chartSeriesColors
      },
      states: {
        hover: {
          filter: {
            type: "none"
          }
        }
      },
      theme: {
        palette: "palette2"
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ]
    };
  }

  ngOnInit(): void {
  }

  ngOnChanges(_changes: SimpleChanges): void {
    // console.log("_changes: ", _changes)
    for (const _propName in _changes) {
      if (_changes.hasOwnProperty(_propName)) {
        switch (_propName) {
          case "chartSeries":
            this.chartOptions.series = _changes?.chartSeries?.currentValue
            break;
          case "chartSeriesLabels":
            this.chartOptions.labels = _changes?.chartSeriesLabels?.currentValue
            break;
          case "chartSeriesColors":
            this.chartOptions.colors = _changes?.chartSeriesColors?.currentValue
            this.chartOptions.fill.colors = _changes?.chartSeriesColors?.currentValue
            break;
          case "chartWidth":
            this.chartOptions.chart.width = _changes?.chartWidth?.currentValue
            break;
          case "chartHeight":
            this.chartOptions.chart.height = _changes?.chartHeight?.currentValue
            break;
          case "chartType":
            this.chartOptions.chart.type = _changes?.chartType?.currentValue
            break;
          case "totalLabel":
            this.chartOptions.plotOptions.pie.donut.labels.total.label = _changes?.totalLabel?.currentValue
            break;
        }
      }
    }
  }

}
